import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=6a71a72e&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=ts&"
export * from "./MainMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=6a71a72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71a72e",
  null
  
)

export default component.exports